import dynamic from 'next/dynamic'
import { type IPage } from '~/types/generated/contentful'

const CustomerSupportModule = dynamic(
  () =>
    import(
      '~/components/page-modules/CustomerSupportModule/CustomerSupportModule'
    ),
)

const VideoPlayer = dynamic(
  () => import('~/components/shared-components/VideoPlayer/VideoPlayer'),
)

const ReferenceValueExtractor = dynamic(
  () =>
    import(
      '../../components/shared-components/ReferenceValueExtractor/ReferenceValueExtractor'
    ),
)

const ComparisonCardModule = dynamic(
  () =>
    import(
      '../../components/page-modules/ComparisonCardModule/ComparisonCardModule'
    ),
)
const AccountComparisonCardModule = dynamic(
  () =>
    import(
      '../../components/page-modules/AccountComparisonCardModule/AccountComparisonCardModule'
    ),
)

const TestimonialsModule = dynamic(
  () =>
    import(
      '../../components/page-modules/TestimonialsModule/TestimonialsModule'
    ),
)

const MapModule = dynamic(
  () => import('~/components/page-modules/MapModule/MapModule'),
)

const QuickLinksModule = dynamic(
  () =>
    import('../../components/page-modules/QuickLinksModule/QuickLinksModule'),
)
const OverdraftCalculatorModule = dynamic(
  () =>
    import(
      '../../components/page-modules/OverdraftCalculatorModule/OverdraftCalculatorModule'
    ),
)

const SavingsCalculatorModule = dynamic(
  () =>
    import(
      '../../components/page-modules/SavingsCalculatorModule/SavingsCalculatorModule'
    ),
)

const IconBannerModule = dynamic(
  () =>
    import('../../components/page-modules/IconBannerModule/IconBannerModule'),
)

const ArticlePreviewTabsModule = dynamic(
  () =>
    import(
      '../../components/page-modules/ArticlePreviewTabsModule/ArticlePreviewTabsModule'
    ),
)

const AwardsTestimoniesBarModule = dynamic(
  () =>
    import(
      '../../components/page-modules/AwardsTestimoniesBarModule/AwardsTestimoniesBarModule'
    ),
)

const FaqBarModule = dynamic(
  () => import('../../components/page-modules/FaqBarModule/FaqBarModule'),
)

const ImageContentBarModule = dynamic(
  () =>
    import(
      '../../components/page-modules/ImageContentBarModule/ImageContentBarModule'
    ),
)

const NewsAndArticlesPreviewModule = dynamic(
  () =>
    import(
      '../../components/page-modules/NewsAndArticlesPreviewModule/NewsAndArticlesPreviewModule'
    ),
)

const PageLinkModule = dynamic(
  () => import('../../components/page-modules/PageLinkModule/PageLinkModule'),
)

const ArticleContentModule = dynamic(
  () =>
    import(
      '../../components/page-modules/ArticleContentModule/ArticleContentModule'
    ),
)

const HeroBannerModule = dynamic(
  () =>
    import('../../components/page-modules/HeroBannerModule/HeroBannerModule'),
)

const ServicesPanelModule = dynamic(
  () =>
    import(
      '../../components/page-modules/ServicesPanelModule/ServicesPanelModule'
    ),
)

const WysiwygContentModule = dynamic(
  () =>
    import(
      '../../components/page-modules/WysiwygContentModule/WysiwygContentModule'
    ),
)

const TextWithArticleCardsModule = dynamic(
  () =>
    import(
      '../../components/page-modules/TextWithArticleCardsModule/TextWithArticleCardsModule'
    ),
)

const VerticalProductCardsModule = dynamic(
  () =>
    import(
      '../../components/page-modules/VerticalProductCardsModule/VerticalProductCardsModule'
    ),
)

const CallToActionBarModule = dynamic(
  () =>
    import(
      '../../components/page-modules/CallToActionBarModule/CallToActionBarModule'
    ),
)

const SocialStripModule = dynamic(
  () =>
    import('../../components/page-modules/SocialStripModule/SocialStripModule'),
)

const ServiceStatusModule = dynamic(
  () =>
    import(
      '../../components/page-modules/ServiceStatusModule/ServiceStatusModule'
    ),
)

const TeamMemberListModule = dynamic(
  () =>
    import(
      '../../components/page-modules/TeamMemberListModule/TeamMemberListModule'
    ),
)

const LargeStandoutTextModule = dynamic(
  () =>
    import(
      '../../components/page-modules/LargeStandoutTextModule/LargeStandoutTextModule'
    ),
)

const VerticalTabsModule = dynamic(
  () =>
    import(
      '../../components/page-modules/VerticalTabsModule/VerticalTabsModule'
    ),
)

const FaqListSectionModule = dynamic(
  () =>
    import(
      '../../components/page-modules/FaqListSectionModule/FaqListSectionModule'
    ),
)

const BreadcrumbModule = dynamic(
  () =>
    import('../../components/page-modules/BreadcrumbModule/BreadcrumbModule'),
)

const PrivateLoanCalculatorModule = dynamic(
  () =>
    import(
      '../../components/page-modules/PrivateLoanCalculatorModule/PrivateLoanCalculatorModule'
    ),
)

const NavigationElement = dynamic(
  () =>
    import(
      '../../components/section-modules/navigation-element/NavigationElement/NavigationElement'
    ),
)

const DocumentLibraryModule = dynamic(
  () =>
    import(
      '../../components/page-modules/DocumentLibraryModule/DocumentLibraryModule'
    ),
)

const InterestRatesModule = dynamic(
  () =>
    import(
      '../../components/page-modules/InterestRatesModule/InterestRatesModule'
    ),
)

type DynamicComponentProps = {
  componentData: any
}

export default function DynamicComponent({
  componentData,
}: DynamicComponentProps) {
  const componentId = componentData?.sys?.contentType?.sys?.id

  switch (componentId) {
    case 'video':
      return <VideoPlayer componentData={componentData} />
    case 'customerSupport':
      return <CustomerSupportModule componentData={componentData} />
    case 'navigationElement':
      return <NavigationElement componentData={componentData} />
    case 'referenceValueExtractor':
      return <ReferenceValueExtractor componentData={componentData} />
    case 'comparisonCards':
      return <ComparisonCardModule componentData={componentData} />
    case 'accountComparisonCards':
      return <AccountComparisonCardModule componentData={componentData} />
    case 'map':
      return <MapModule componentData={componentData} />
    case 'testimonials':
      return <TestimonialsModule componentData={componentData} />
    case 'newsAndArticlesPreview':
      return <NewsAndArticlesPreviewModule componentData={componentData} />
    case 'articleContent':
      return <ArticleContentModule componentData={componentData} />
    case 'articlePreviewTabs':
      return <ArticlePreviewTabsModule componentData={componentData} />
    case 'faQsBar':
      return <FaqBarModule componentData={componentData} />
    case 'heroBanner':
      return <HeroBannerModule componentData={componentData} />
    case 'pageLinks':
      return <PageLinkModule componentData={componentData} />
    case 'iconBanner':
      return <IconBannerModule componentData={componentData} />
    case 'quickLinks':
      return <QuickLinksModule componentData={componentData} />
    case 'imageContentBar':
      return <ImageContentBarModule componentData={componentData} />
    case 'awardsTestimoniesBar':
      return <AwardsTestimoniesBarModule componentData={componentData} />
    case 'servicesPanel':
      return <ServicesPanelModule componentData={componentData} />
    case 'wysiwygContent':
      return <WysiwygContentModule componentData={componentData} />
    case 'overdraftCalculator':
      return <OverdraftCalculatorModule componentData={componentData} />
    case 'savingsCalculator':
      return <SavingsCalculatorModule componentData={componentData} />
    case 'textWithArticleCards':
      return <TextWithArticleCardsModule componentData={componentData} />
    case 'verticalProductCards':
      return <VerticalProductCardsModule componentData={componentData} />
    case 'callToActionBar':
      return <CallToActionBarModule componentData={componentData} />
    case 'socialStrip':
      return <SocialStripModule componentData={componentData} />
    case 'serviceStatus':
      return <ServiceStatusModule componentData={componentData} />
    case 'teamMemberList':
      return <TeamMemberListModule componentData={componentData} />
    case 'page':
      return componentData.fields.pageContent?.map(
        (componentData: IPage, index: number) => (
          <DynamicComponent
            key={`${componentData.sys.id}-${index}`}
            componentData={componentData}
          />
        ),
      )
    case 'largeStandoutText':
      return <LargeStandoutTextModule componentData={componentData} />
    case 'verticalTabs':
      return <VerticalTabsModule componentData={componentData} />
    case 'faqListSection':
      return <FaqListSectionModule componentData={componentData} />
    case 'breadcrumb':
      return <BreadcrumbModule componentData={componentData} />
    case 'privateLoanCalculator':
      return <PrivateLoanCalculatorModule componentData={componentData} />
    case 'documentLibrary':
      return <DocumentLibraryModule componentData={componentData} />
    case 'interestRates':
      return <InterestRatesModule componentData={componentData} />
    default:
      return <div>Unknown component type {componentId}</div>
  }
}
